import React, { useState, useEffect } from 'react';
import { useParams }                  from 'react-router-dom';
import Exhibit                        from '../atoms/exhibit';

import { articleSearch }              from '../../../apis/article';

const initialState = {
    data : "",
};

export default function Story () {
	const { id }               = useParams ();
	const [{ data }, setState] = useState (initialState);

	useEffect(() => {
		const getData = async () => {
			try {
				const resp = await articleSearch ({ 'url' : id });
				setState (prevState => ({ ...prevState, 'data': resp }));

				document.title = `${resp.title} | Overseas.one`;
				document.getElementsByTagName ("META")[3].name = resp.seo_title;
				document.getElementsByTagName ("META")[3].content = resp.seo_desc;
				document.getElementsByTagName ("META")[4].content = resp.seo_desc;
			} catch (err) {
				setState (prevState => ({ ...prevState, 'data': null }));
				document.title = `Page Not Found | Overseas.one`;
				console.error (err);
			}
		}
		getData ();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (data === null)
		return (
			<p>Compoenent to say NO DATA FOUND.<br /> SUGGESTED ARTICLES </p>
		);

	return (
		<div style={{padding: '20px'}}>
			<Exhibit data={data} />
		</div>
	);
}
